export default function CuantoConoces(){
    return(
        <h1>Cuanto lx conoces?</h1>
        )
}